import React from "react";
import ImmediateSEOTags from "../component/DynamicSEO/ImmediateSEOTags";
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";

const ExampleWithDynamicSEO = () => {
  return (
    <>
      {/* This will apply SEO tags immediately and work with static generation */}
      <ImmediateSEOTags
        fallbackTitle="Example Page | Polani Travels"
        fallbackDescription="This is an example page demonstrating dynamic SEO functionality with Firebase backend."
        fallbackKeywords="example, dynamic seo, firebase, polani travels"
        fallbackOgTitle="Example Page | Polani Travels"
        fallbackOgDescription="This is an example page demonstrating dynamic SEO functionality with Firebase backend."
        fallbackCanonicalUrl="https://polani-2c215.web.app/example"
      />

      <CommonBanner
        heading="Example Page with Dynamic SEO"
        img={ImageConstants.aboutus}
        pagination="Example"
      />

      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="card">
              <div className="card-body">
                <h2 className="card-title">Immediate SEO Example</h2>
                <p className="card-text">
                  This page demonstrates how to use the immediate SEO system
                  that works with react-snap. The SEO meta tags are applied
                  immediately when the page loads and will be visible in the
                  "View Source" of the generated static HTML.
                </p>

                <h4>How it works:</h4>
                <ul>
                  <li>SEO settings are loaded from Firebase on page load</li>
                  <li>
                    Meta tags are rendered immediately with fallback values
                  </li>
                  <li>Works perfectly with react-snap static generation</li>
                  <li>SEO tags appear in "View Source" immediately</li>
                  <li>No complex preloading required</li>
                </ul>

                <h4>Key Features:</h4>
                <ul>
                  <li>✅ Immediate SEO tag application</li>
                  <li>✅ Static generation compatible</li>
                  <li>✅ View Source friendly</li>
                  <li>✅ Fallback to static SEO if no dynamic settings</li>
                  <li>✅ All meta tags (OG, Twitter, etc.)</li>
                  <li>✅ Canonical URLs and robots meta</li>
                  <li>✅ Simple implementation - no build script changes</li>
                </ul>

                <div className="alert alert-info">
                  <strong>Note:</strong> To see this in action, create SEO
                  settings for this page in the{" "}
                  <a href="/seo-portal" className="alert-link">
                    SEO Portal
                  </a>{" "}
                  with the path "/example". Then rebuild your site with
                  react-snap to see the SEO tags in the static HTML.
                </div>

                <div className="alert alert-success">
                  <strong>Testing:</strong> Right-click and "View Page Source"
                  to see the SEO meta tags that are generated immediately when
                  the page loads.
                </div>

                <div className="alert alert-warning">
                  <strong>Build Process:</strong> This approach doesn't require
                  any build script changes, making it simpler to implement and
                  maintain.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExampleWithDynamicSEO;
